import React from 'react';
import styled from 'styled-components';

const StyledBlogBanner = styled.section`
	background: url(${({ bannerImage }) => bannerImage}), #004563;
	min-height: 400px;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: top;

	@media screen and (max-width: 767px) {
		min-height: 350px;
	}

	h1 {
		max-width: 740px;
		margin: auto;
		font-size: 40px;
		line-height: 48px;

		@media screen and (max-width: 767px) {
			font-size: 30px;
			line-height: 36px;
		}
	}
`;

const Banner = ({ bannerData, bannerTitle }) => {
	return (
		<StyledBlogBanner
			className='d-flex align-items-center text-center'
			bannerImage={bannerData?.fields?.file?.url}
		>
			<div className='container'>
				<h1 className='text-white'>{bannerTitle}</h1>
			</div>
		</StyledBlogBanner>
	);
};

export default Banner;
